import { z } from 'zod';
import { UUIDSchema, ISODateSchema, ISODateTimeSchema } from './common';
import { ValueOverviewAddressSchema } from './value-overview';
import { FileSchema, FileWithContentTypeSchema, ImageWithContentTypeSchema } from './file';
import { ValuationImageSchema } from './valuation';
import { AppraiserLegacyUserSchema, ClientPortalLegacyUserSchema } from './user';
export const OrderTaskStatusSchema = z.enum(['open', 'done']);
export const TaskTypeSchema = z.enum(['system', 'appraiser', 'customer']);
export const TaskCreatedBySchema = z.object({
    id: z.number(),
    email: z.string(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
});
export const TaskAssigneeSchema = TaskCreatedBySchema.extend({
    organization_name: z.string().optional(),
});
export const NewOrderTaskSchema = z.object({
    order_uuid: UUIDSchema,
    title: z.string(),
    description: z.string(),
    assignee: TaskAssigneeSchema.optional(),
    status: OrderTaskStatusSchema,
    due_date: ISODateSchema.optional(),
    has_limited_visibility: z.boolean().optional(),
});
export const OrderTaskSchema = NewOrderTaskSchema.extend({
    uuid: UUIDSchema,
    task_type: TaskTypeSchema,
    communication_thread: UUIDSchema,
    documents: FileSchema.array(),
    images: ValuationImageSchema.array(),
    created_by: TaskCreatedBySchema.optional(),
    created_on: ISODateTimeSchema,
});
export const TaskOrderSchema = z.object({
    uuid: UUIDSchema,
    address: ValueOverviewAddressSchema,
});
export const TaskAssetSchema = z.object({
    uuid: UUIDSchema,
    title: z.string(),
    address: ValueOverviewAddressSchema,
});
export const TaskOverviewAssigneeSchema = TaskCreatedBySchema.extend({
    team: z.string().optional(),
});
export const TaskOverviewSchema = z.object({
    uuid: UUIDSchema,
    communication_thread: UUIDSchema,
    title: z.string(),
    description: z.string(),
    created_by: TaskCreatedBySchema.optional(),
    assignee: TaskOverviewAssigneeSchema.optional(),
    due_date: ISODateSchema.optional(),
    status: OrderTaskStatusSchema,
    order: TaskOrderSchema,
    asset: TaskAssetSchema.optional(),
    has_limited_visibility: z.boolean(),
    task_type: TaskTypeSchema,
});
export const CustomerTaskCreatedBySchema = TaskCreatedBySchema.extend({
    role: z.string(),
});
export const CustomerTaskTeamSchema = z.object({
    name: z.string(),
    uuid: UUIDSchema,
});
export const CustomerTaskOverviewAssigneeSchema = TaskCreatedBySchema.extend({
    team: CustomerTaskTeamSchema.optional(),
});
export const CustomerTaskOrderSchema = TaskOrderSchema.extend({
    customer_asset_reference: z.string().optional(),
});
export const CustomerNewOrderTaskSchema = NewOrderTaskSchema.omit({
    has_limited_visibility: true,
}).extend({
    created_on: ISODateTimeSchema,
});
export const CustomerOrderTaskSchema = CustomerNewOrderTaskSchema.extend({
    uuid: UUIDSchema,
    communication_thread: UUIDSchema,
    documents: FileWithContentTypeSchema.array(),
    images: ImageWithContentTypeSchema.array(),
    created_by: CustomerTaskCreatedBySchema.optional(),
    task_type: TaskTypeSchema,
});
export const CustomerTaskOverviewSchema = z.object({
    uuid: UUIDSchema,
    communication_thread: UUIDSchema,
    title: z.string(),
    description: z.string(),
    created_by: CustomerTaskCreatedBySchema.optional(),
    assignee: CustomerTaskOverviewAssigneeSchema.optional(),
    due_date: ISODateSchema.optional(),
    status: OrderTaskStatusSchema,
    order: CustomerTaskOrderSchema,
    task_type: TaskTypeSchema,
});
export const TaskOverviewSortingFieldsSchema = z.enum(['+due_date', '-due_date', '+title', '-title']);
export const TaskListSchema = z.object({ tasks: TaskOverviewSchema.array() });
export const CustomerTaskListSchema = z.object({ tasks: CustomerTaskOverviewSchema.array() });
export const ValuationTaskChangePropertySchema = z.enum([
    'title',
    'description',
    'assignee',
    'due_date',
    'status',
    'file',
    'image',
    'has_limited_visibility',
]);
export const ValuationTaskChangeSchema = z.object({
    author_user: AppraiserLegacyUserSchema,
    timestamp: ISODateTimeSchema,
    changed_property: ValuationTaskChangePropertySchema,
    old: z.string().optional(),
    new: z.string().optional(),
});
export const CustomerValuationTaskChangeSchema = ValuationTaskChangeSchema.extend({
    author_user: ClientPortalLegacyUserSchema,
});
export const ValuationTaskChangeLogSchema = z.object({
    changes: ValuationTaskChangeSchema.array(),
});
export const CustomerValuationTaskChangeLogSchema = z.object({
    changes: CustomerValuationTaskChangeSchema.array(),
});
